import styles from "./loader.module.css";

function Loader() {
  return <div className={styles.loader} />;
}

export default Loader;
